import React from "react";
import { LEVEL_META } from "../lib/risk";
import { useI18n } from "../lib/i18n";

export function ScoreGauge({ score, level }) {
  const { t } = useI18n();
  const meta = LEVEL_META[level] || LEVEL_META.MEDIO;
  const r = 90;
  const c = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(100, score)) / 100;
  const dash = c * pct;

  return (
    <div className="relative flex items-center justify-center" data-testid="score-gauge">
      <svg width="220" height="220" viewBox="0 0 220 220" className="-rotate-90">
        <circle cx="110" cy="110" r={r} fill="none" stroke="#EEF2F6" strokeWidth="14" />
        <circle
          cx="110"
          cy="110"
          r={r}
          fill="none"
          stroke={meta.color}
          strokeWidth="14"
          strokeLinecap="round"
          strokeDasharray={`${dash} ${c}`}
          style={{ transition: "stroke-dasharray 1.1s cubic-bezier(0.22,1,0.36,1)" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div className="font-display font-bold tracking-tighter text-6xl text-navy leading-none">
          {score}
        </div>
        <div className="label-caps mt-1" style={{ color: "#94a3b8" }}>
          / 100
        </div>
        <div
          className="mt-3 px-3 py-1 rounded-md text-xs font-bold tracking-widest"
          style={{ color: meta.color, background: meta.bg, border: `1px solid ${meta.border}` }}
        >
          {t(`risk.${level}`)}
        </div>
      </div>
    </div>
  );
}
